import {Service} from "@/apiServices/Service";

export class AreaService extends Service {
    constructor() {
        super('catalogos/areas/');
    }
    listar(request, params, config) {
        this.onStart();
        return this.http.post(this.getUrl(['obtenerAreas','activas'], params), request, config)
            .then((response) => this.onData(response))
            .then(response => {
                this.data = response.data;
                this.data = this.orderAscData('nombreArea');
                return this.data;
            })
            .catch((e) => {
                this.onError(e);
                this.data = {data: []};
                this.loading = false;
            })
            .finally(() => {
                this.onFinaly();
            })
    }
}